module.exports = __webpack_public_path__ + "img/The-Good-Gateway-Green-07.8db27045.jpg";